import { render, staticRenderFns } from "./HomeWeddingDay.vue?vue&type=template&id=24cb901b&scoped=true&"
import script from "./HomeWeddingDay.vue?vue&type=script&lang=js&"
export * from "./HomeWeddingDay.vue?vue&type=script&lang=js&"
import style0 from "./HomeWeddingDay.vue?vue&type=style&index=0&id=24cb901b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24cb901b",
  null
  
)

export default component.exports